export default {
  "slots": {
    "root": "my-5"
  }
}